import { render, staticRenderFns } from "./SetIncomeTaxes.vue?vue&type=template&id=4bede2e2"
import script from "./SetIncomeTaxes.vue?vue&type=script&lang=js"
export * from "./SetIncomeTaxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports